import {useMemo} from 'react';
import constants from 'helpers/constants';
import utils from 'helpers/utils';

export function processInsight (insight) {
  insight = utils.camelcaseEx(insight);

  return insight;
}

export function useInsightLocation (insight) {
  return useMemo(() => {
    if (insight) {
      const entities = insight.entities || [];
      if (+insight.collection?.collectionId > 0 && !insight.collection.isUniverse) {
        return {
          ...constants.data.lookup('insightLocations', constants.task.locations.collection),
          label: insight.collection.name
        };
      }
      if (!entities.some((e) => !(+e?.csi?.status > 0))) {
        return constants.data.lookup('insightLocations', constants.task.locations.dealflow);
      }
      return constants.data.lookup('insightLocations', constants.task.locations.database);
    } else {
      return constants.data.lookup('insightLocations', constants.task.locations.database);
    }
  }, [insight]);
}
